import { render, staticRenderFns } from "./SurfaceSelection.vue?vue&type=template&id=ae2c1a88&"
import script from "./SurfaceSelection.vue?vue&type=script&lang=js&"
export * from "./SurfaceSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports